export const PageDataState = {
    Searchs: {
        name: {
            type: 'text',
            id: 'name',
            label: 'ชื่อ',
            value: '',
            placeholder: 'ชื่อ',
        },
        lastname: {
            type: 'text',
            id: 'lastname',
            label: 'นามสกุล',
            value: '',
            placeholder: 'นามสกุล',
        },
        national_id: {
            type: 'text',
            id: 'national_id',
            label: 'บัตรประชาชน',
            value: '',
            placeholder: 'เลขประจำตัวประชาชน',
        },
        phone_number: {
            type: 'text',
            id: 'phone_number',
            label: 'เบอร์โทรศัพท์',
            value: '',
            placeholder: 'เบอร์โทรศัพท์',
        }        
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: ''}
        },
        prefix_code: {
            type: 'select',
            id: 'prefix_code',
            label: 'คำนำหน้า',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: ''}
        },
        name: {
            type: 'text',
            id: 'name',
            label: 'ชื่อ',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 2,
                maxLength: 255
            },
            error: { status: null, msg: ''}
        },
        lastname: {
            type: 'text',
            id: 'lastname',
            label: 'นามสกุล',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 2,
                maxLength: 255
            },
            error: { status: null, msg: ''}
        },
        image: {
            type: 'file',
            id: 'image',
            label: 'รูปภาพ',
            fileId: '',  
            fileName: '', 
            fileInfo: {},
            value: '',
            validator: {
                type: 'file',
                required: false,
                accept: "image/png,image/jpeg",
            },
            error: { status: null, msg: '' }
        },
        birthdate: {
            type: 'text',
            id: 'birthdate',
            label: 'วันเดือนปี เกิด',
            value: '',
            validator: {
                type: 'date',
                required: true,
            },
            error: { status: null, msg: '' }
        },
        national_id: {
            type: 'text',
            id: 'national_id',
            label: 'บัตรประชาชน',
            value: '',
            placeholder: 'เลขประจำตัวประชาชน',
            validator: {
                type: 'text',
                required: false,
                minLength: 13,
                maxLength: 13
            },
            error: { status: null, msg: ''}
        },
        phone_number: {
            type: 'text',
            id: 'phone_number',
            label: 'เบอร์โทรศัพท์',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 10,
                maxLength: 255
            },
            error: { status: null, msg: ''}
        },
        location: {
            type: 'textarea',
            rows: 3,
            id: 'location',
            label: 'ที่อยู่',
            value: '',
            validator: {
                type: 'text',
                required: true,
                minLength: 5,
                maxLength: 4096
            },
            error: { status: null, msg: ''}
        },
        email: {
            type: 'text',
            id: 'email',
            label: 'อีเมล',
            value: '',
            validator: {
                type: 'email',
                required: false,
                minLength: 5,
                maxLength: 250
            },
            error: { status: null, msg: '' }
        },
    },
    InputGroup: {}
}